import React from "react";
import { Skeleton } from "@mui/material";

export function SkelletonTableGrid() {
  return (
    <>
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
          marginBottom: 8,
        }}
      >
        <div
          style={{
            display: "flex",
            width: "50%",
          }}
        >
          <Skeleton
            variant="rounded"
            style={{ marginLeft: 8 }}
            width="100%"
            height="2.2rem"
          />
          <Skeleton
            variant="rounded"
            style={{ marginLeft: 8 }}
            width="2.375rem"
            height="2.2rem"
          />
          <Skeleton
            variant="rounded"
            style={{ marginLeft: 8 }}
            width="5.375rem"
            height="2.2rem"
          />
          <Skeleton
            variant="rounded"
            style={{ marginLeft: 8 }}
            width="5.375rem"
            height="2.2rem"
          />
        </div>
        <div
          style={{
            display: "flex",
          }}
        >
          <Skeleton variant="rounded" width="17.375rem" height="2.2rem" />
          <Skeleton
            variant="rounded"
            style={{ marginLeft: 4 }}
            width="2.375rem"
            height="2.2rem"
          />
        </div>
      </div>
    </>
  );
}
